import { render, staticRenderFns } from "./ActionImage.vue?vue&type=template&id=47129dfa&scoped=true&"
import script from "./ActionImage.vue?vue&type=script&lang=js&"
export * from "./ActionImage.vue?vue&type=script&lang=js&"
import style0 from "./ActionImage.vue?vue&type=style&index=0&id=47129dfa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47129dfa",
  null
  
)

export default component.exports